// WelcomeUserPopup.tsx
import React from "react";
import { GifIcon, MedalSolidIcon, ForwardIcon } from "components/icons";
import PopupContainer from "components/PopupContainer";

// Props interface for the component
interface WelcomeUserPopupProps {
  open: boolean;
  userName: string; // To dynamically display the user's name
  onStartCreating: () => void; // Callback for the "Start creating now" button

  onClose: () => void;
}

const WelcomeUserPopup: React.FC<WelcomeUserPopupProps> = ({
  userName,
  open,
  onClose,
  onStartCreating,
}) => {
  return (
    <PopupContainer open={open} onClose={onClose}>
      {/* Gradient Border (Top) */}
      <div className="relative py-3">
        <div
          className="absolute top-0 left-0 right-0 h-3 rounded-t-lg border-t-[0.8px] border-dashed border-[#4338CA]"
          style={{
            background: "linear-gradient(90deg, #6565F0 0%, #EA499C 100%)",
          }}
        />

        {/* Emoji Icon */}
        <div className="flex justify-center mt-6 mb-[24px] ">
          <div className="w-[60px] h-[60px] bg-[rgba(254,243,199,0.50)] rounded-full flex items-center justify-center text-[36px]">
            🥳
          </div>
        </div>

        {/* Welcome Message */}
        <h1 className="text-[20px] font-bold text-center text-[#171717] mb-3">
          Welcome, {userName}!
        </h1>
        <p className="text-[#525252] text-[14px] text-center mb-6">
          Your creative journey begins now
        </p>

        {/* Welcome Gifts Section */}
        <div
          className="rounded-[6px] mb-6 p-[10px] max-w-[325px] w-full mx-auto"
          style={{
            background: "linear-gradient(90deg, #F3E8FF 0%, #DBE9FE 100%)",
          }}
        >
          <div className="text-[14px] text-[#3730A3] font-semibold text-center mb-[14px] flex flex-row items-center justify-center gap-2">
            <GifIcon />
            <span>Your welcome gifts</span>
          </div>
          <div className="flex items-center justify-center space-x-2 bg-white p-[10px] rounded-[6px]">
            <div className="w-[35px] h-[35px] bg-[#E0E7FF] rounded-full flex items-center justify-center">
              <MedalSolidIcon />
            </div>
            <p className="flex flex-col">
              <span className="font-semibold text-[16px] text-[#171717]">
                1 Free image generations daily
              </span>
              <span className="text-[#737373] text-[12px]">
                10x your productivity
              </span>
            </p>
          </div>
        </div>

        {/* Start Creating Button */}
        <button
          onClick={onStartCreating}
          className="w-full bg-[#5046E6] max-w-[325px] text-[16px] font-semibold h-[35px] text-white mx-auto rounded-[6px] flex items-center justify-center space-x-2 shadow-[0px_2px_4px_0px_rgba(0,0,0,0.25)]"
        >
          <span> Start creating now</span>
          <ForwardIcon />
        </button>

        {/* Check Email Note */}
        <p className="text-[#737373] text-[12px] font-medium text-center my-3 max-w-[325px] mx-auto leading-[14px]">
          Check your email for additional information about your account
        </p>
      </div>
    </PopupContainer>
  );
};

export default WelcomeUserPopup;
